module.exports = __webpack_public_path__ + "img/pro-photo4.dbd336db.png";